module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/Item/images/selected-small.92022356.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/Item/images/selected-small.png
// module id = 3076
// module chunks = 11